import React from 'react';
import {connect} from 'react-redux';
import BaseMultConsumption from 'components/BaseMultConsumption';
import {getConsumptionByApp} from 'actions/consumption';
import {getChartSeries} from 'utils/consumptionTool';


const SKULIST = [
    {
        name:'StarScope',
        contract_type:73,
        columns:[
            {
                title: 'Time',
                dataIndex: 'day',
                key: 'day',
                sorter:true
            },{
                title: 'Count',
                dataIndex: 'deepfake_count',
                key: 'deepfake_count',
                sorter:true
            }
        ],
        subTitleRender:(data)=>{
            const total = data.total || {};
            return <p>(Deepfake Count: <span style={{color:'#6D74F4'}}>{total.deepfake_count||0}</span>)</p>;
        },
        chartSeries:getChartSeries([
            {
                key:'deepfake_count',
                name:'Count',
                color:'#8A90FF'
            }
        ])
    },
];
class StarScopeConsumption extends React.Component {

    render() {
        return (
            <BaseMultConsumption
                skuList={SKULIST}
                getInfoPromise={getConsumptionByApp}
            />
        );

    }

}


function select(state) {
    return {
        account: state.account.info
    };
}
export default connect(select)(StarScopeConsumption);



// WEBPACK FOOTER //
// ./src/pages/StarScopeConsumption/index.js